<mat-card class="app-main-container app-form-container">
  <mat-card-header class="custom-card-header between">
    <mat-card-title class="card-title">
      <mat-icon class="title-icon">policy</mat-icon>
      Tietosuojaseloste – RaksaInfo-järjestelmä
    </mat-card-title>
  </mat-card-header>

  <mat-card-content class="p-2">
    <p class="mb-2 text-faint">Päivitetty: 29.9.2026</p>

    <section class="privacy-section">
      <h2>1. Rekisterinpitäjä</h2>
      <p>LTQ-Rakennus Oy</p>
      <p>Muuntotie 3, 01510 Vantaa, Suomi</p>
      <p>Y-tunnus: 3012235-9</p>
      <p>Toimisto avoinna arkisin klo 8–16</p>
      <p>Sähköposti: ltqrakennus[at]ltq.fi / etunimi.sukunimi[at]ltq.fi</p>
      <p>Puhelin: +358 50 430 5919</p>
    </section>

    <section class="privacy-section">
      <h2>2. Tietosuoja-asioiden yhteyshenkilö</h2>
      <p>Erillistä tietosuojavastaavaa ei ole nimetty.</p>
      <p>Tietosuoja-asioiden yhteyshenkilö:</p>
      <p>Sähköposti: tietosuoja[at]ltq.fi</p>
    </section>

    <section class="privacy-section">
      <h2>3. Rekisterin nimi ja käyttötarkoitus</h2>
      <p><strong>Nimi:</strong> RaksaInfo-järjestelmän käyttäjä- ja työaikarekisteri.</p>
      <p>
        Rekisteri sisältää rekisterinpitäjän työntekijöiden, asiakkaiden, aliurakoitsijoiden
        ja näiden työntekijöiden sekä muiden käyttäjien henkilötietoja. Tietoja käytetään
        työsuhteen, projektien, työmaiden, laskutuksen, työajanseurannan ja
        käyttöoikeuksien hallintaan sekä tietoturvan varmistamiseen.
      </p>
    </section>

    <section class="privacy-section">
      <h2>4. Rekisteröidyt</h2>
      <ul>
        <li>rekisterinpitäjän työntekijät ja harjoittelijat</li>
        <li>asiakasyritysten yhteyshenkilöt</li>
        <li>aliurakoitsijoiden ja kumppaniyritysten työntekijät</li>
        <li>muut RaksaInfo-järjestelmän käyttäjät.</li>
      </ul>
    </section>

    <section class="privacy-section">
      <h2>5. Käsiteltävät henkilötiedot</h2>
      <p><strong>Perustiedot:</strong> nimi, yhteystiedot (sähköposti, puhelin), käyttäjätunnus, yrityksen nimi ja rooli, työntekijänumero ja veronumero.</p>
      <p><strong>Työaika ja työsuhde:</strong> työaikamerkinnät, tehdyt tunnit, projektit ja työmaat, ylityöt, poissaolot ja lomat, sairauspoissaolojen ajankohdat (ei diagnooseja).</p>
      <p><strong>Yritystiedot (B2B):</strong> asiakas- ja aliurakoitsijayritysten nimi, Y-tunnus, osoite, laskutusosoitteet, projekti- ja työmaatiedot.</p>
      <p><strong>Käyttö- ja lokitiedot:</strong> kirjautumis- ja auditointilokit, IP-osoitteet, tekniset virhelokit ja audit trail -tiedot.</p>
    </section>

    <section class="privacy-section">
      <h2>6. Käsittelyn tarkoitukset ja oikeusperusteet</h2>
      <ul>
        <li><strong>Työajan ja työsuhteen hallinta</strong> (GDPR 6.1.b, 6.1.c)</li>
        <li><strong>Projektien, työmaiden ja asiakkaiden hallinta</strong> (6.1.b, 6.1.f)</li>
        <li><strong>Laskutus ja taloushallinto</strong> (6.1.b, 6.1.c)</li>
        <li><strong>Tietoturva ja lokitus</strong> (6.1.f)</li>
        <li><strong>Palvelun kehittäminen ja raportointi</strong> (6.1.f)</li>
      </ul>
      <p>
        Terveystietoja ei käsitellä diagnooseina. Sairauspoissaoloista tallennetaan
        ainoastaan poissaolon ajankohta ja kesto, ei syytä.
      </p>
    </section>

    <section class="privacy-section">
      <h2>7. Säilytysajat</h2>
      <ul>
        <li>Työaika- ja laskutustiedot säilytetään pääsääntöisesti 10 vuotta kirjanpito- ja verolainsäädännön mukaisesti.</li>
        <li>Käyttäjätilit passivoidaan työsuhteen päätyttyä, mutta tiedot säilytetään lakisääteisen säilytysajan työaika- ja työsuhdetietojen eheyttä varten.</li>
        <li>Lokit ja audit trail säilytetään tyypillisesti 1–5 vuotta, ellei pidempi säilytys ole tarpeen.</li>
      </ul>
    </section>

    <section class="privacy-section">
      <h2>8. Henkilötietojen lähteet</h2>
      <ul>
        <li>rekisteröidyt itse (käyttäjäprofiilit, kirjaukset)</li>
        <li>rekisterinpitäjän esimiehet ja hallinto</li>
        <li>järjestelmän lokit ja auditointimekanismit</li>
        <li>tuotedata voi tulla muista järjestelmistä; henkilötietoja ei tuoda ulkoisista henkilörekistereistä.</li>
      </ul>
      <p>
        Järjestelmästä viedään tarvittaessa tietoja HR- ja taloushallinnon järjestelmiin
        (esimerkiksi Mepco ja Netvisor), joissa rekisterinpitäjä toimii omana rekisterinpitäjänä.
      </p>
    </section>

    <section class="privacy-section">
      <h2>9. Vastaanottajat ja alikäsittelijät</h2>
      <p>Henkilötietoja voidaan luovuttaa:</p>
      <ul>
        <li>viranomaisille lain niin edellyttäessä</li>
        <li>asiakas- ja aliurakoitsijasopimusten edellyttämällä tavalla.</li>
      </ul>
      <p>Rekisterinpitäjä käyttää palveluntarjoajia henkilötietojen käsittelijöinä:</p>
      <ul>
        <li>Microsoft Azure (EU-alue, hosting)</li>
        <li>SendGrid (sähköpostiviestit)</li>
        <li>Elisa SMS API (tekstiviestit).</li>
      </ul>
    </section>

    <section class="privacy-section">
      <h2>10. Siirrot EU/ETA-alueen ulkopuolelle</h2>
      <p>
        Palvelu on pääsääntöisesti hostattu EU/ETA-alueella. Mikäli yksittäinen
        alipalvelu käsittelee tietoja EU/ETA-alueen ulkopuolella, siirto perustuu
        EU:n komission hyväksymiin mallisopimuslausekkeisiin tai muuhun GDPR:n
        5. luvun mukaiseen siirtoperusteeseen.
      </p>
    </section>

    <section class="privacy-section">
      <h2>11. Tietojen suojaus</h2>
      <ul>
        <li>roolipohjaiset käyttöoikeudet ja kirjautuminen</li>
        <li>salattu yhteys (HTTPS)</li>
        <li>Azure-ympäristön fyysiset ja tekniset suojausratkaisut</li>
        <li>loki- ja audit trail -seuranta.</li>
      </ul>
    </section>

    <section class="privacy-section">
      <h2>12. Automaattinen päätöksenteko ja profilointi</h2>
      <p>
        Järjestelmä ei tee automatisoituja yksittäispäätöksiä tai profilointia,
        joilla olisi merkittäviä oikeusvaikutuksia rekisteröityihin.
      </p>
    </section>

    <section class="privacy-section">
      <h2>13. Rekisteröidyn oikeudet</h2>
      <p>Rekisteröidyllä on EU:n tietosuoja-asetuksen mukaiset oikeudet, kuten:</p>
      <ul>
        <li>oikeus saada pääsy omiin tietoihin</li>
        <li>oikeus tietojen oikaisemiseen</li>
        <li>oikeus tietojen poistamiseen tietyin edellytyksin</li>
        <li>oikeus käsittelyn rajoittamiseen ja vastustamiseen</li>
        <li>oikeus siirtää tiedot järjestelmästä toiseen.</li>
      </ul>
      <p>
        Kirjautunut käyttäjä voi käyttää osaa oikeuksistaan suoraan RaksaInfossa
        <a routerLink="/omat-tiedot">Omat tiedot</a> -sivulla (käyttäjävalikko):
      </p>
      <ul>
        <li>omien tietojen tarkastelu (pääsy tietoihin)</li>
        <li>tietojen oikaisu: nimi, yhteystiedot, veronumero ja syntymäaika</li>
        <li>omien tietojen lataaminen koneluettavassa muodossa</li>
        <li>käyttäjätilin sulkeminen.</li>
      </ul>
      <p>
        Työntekijänumeron ja esimiehen kaltaiset tiedot ylläpitää työnantaja. Muut pyynnöt,
        kuten käsittelyn rajoittaminen tai vastustaminen, voi esittää osoitteeseen
        tietosuoja[at]ltq.fi.
      </p>
    </section>

    <section class="privacy-section">
      <h2>14. Valitusoikeus</h2>
      <p>
        Rekisteröidyllä on oikeus tehdä valitus tietosuojavaltuutetulle, jos hän
        katsoo, että häntä koskevien henkilötietojen käsittelyssä rikotaan
        tietosuojasääntelyä. Lisätiedot: www.tietosuoja.fi.
      </p>
    </section>

    <section class="privacy-section">
      <h2>15. Evästeet ja lokit</h2>
      <p>
        RaksaInfo on B2B-järjestelmä, jonka käyttö edellyttää kirjautumista.
        Järjestelmä ei tällä hetkellä käytä erillisiä analytiikkapalveluita. Tekniset
        lokit (mm. IP-osoitteet ja virheilmoitukset) tallentuvat palvelun
        toiminnan ja tietoturvan varmistamiseksi.
      </p>
    </section>

    <section class="privacy-section">
      <h2>16. Selosteen muutokset</h2>
      <p>
        Rekisterinpitäjä voi päivittää tietosuojaselostetta esimerkiksi
        lainsäädännön muutosten tai palvelun kehittämisen yhteydessä. Olennaisista
        muutoksista pyritään ilmoittamaan järjestelmän kautta.
      </p>
    </section>
  </mat-card-content>
</mat-card>

